import React from 'react';
import classnames from 'classnames/bind';
import styles from './BankChooser.module.scss';

const cx = classnames.bind(styles);

function BankChooser({ bankList, selectedBank = '', onClick }) {
	return (
		<ul className={cx('bank_list')}>
			{bankList.map(({ value, label, icon }) => (
				<li
					key={value}
					className={cx('bank_item', { selected: selectedBank === value })}
				>
					<button
						type="button"
						className={cx('btn_bank')}
						onClick={() => onClick(value)}
					>
						<span className={cx('ico_bank', `ico_${icon}`)}>{`${label} 아이콘`}</span>
						<span className={cx('bank_label')}>{label}</span>
					</button>
				</li>
			))}
		</ul>
	);
}

export default BankChooser;
